import React, { ReactElement } from 'react';
import { SxProps, Theme, styled } from '@mui/material';
import Image from '@mui/icons-material/Image';
import Container from './Container';

const CustomImage = styled('img')<{ sizeH?: number, sizeV?: number }>(({ sizeH, sizeV, theme }) => ({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  ...(sizeH && { maxWidth: sizeH }),
  ...(sizeV && { maxHeight: sizeV }),
  display: 'block',
  margin: 'auto',
  verticalAlign: 'inherit',
}));

const Placeholder = styled(Container)<{ size?: number }>(({ size, color, theme }) => ({
  color: color || theme.palette.grey[400],
  verticalAlign: 'middle',
  textAlign: 'center',
  ...(size && { height: `${size}px`, lineHeight: `${size}px` })
}));

export type ImageProps = {
  source?: string | null | false,
  sizeH?: number,
  sizeV?: number,
  placeholder?: ReactElement,
  color?: string,
  sx?: SxProps<Theme>
};

export default ({
  source = null,
  sizeH,
  sizeV,
  placeholder,
  color,
  sx
}: ImageProps) => {
  if (!source) {
    return <Placeholder size={sizeV} color={color}>
      {placeholder
        ? placeholder
        : <Image
            sx={{
              fontSize: (`${sizeV && Math.round(sizeV / 5)}px`) || 'inherit',
              verticalAlign: 'inherit'
            }}
          />
      }
    </Placeholder>;
  }
  return <CustomImage src={source} sizeH={sizeH} sizeV={sizeV} sx={sx}/>;
};